<template>
  <v-layout wrap>
    <v-flex  xs12 class="text-xs-center">
      <v-alert v-if="user.experience==''" :value="true" type="warning">Please update your experience</v-alert>
      <v-dialog v-model="dialog" max-width="750px">
        <v-btn color="btnColor" dark slot="activator" class="mb-2" flat>
          <v-icon>add</v-icon>Update Experience
        </v-btn>
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Experience Update</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="close">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 class="experience"> I/We have experience of about... </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete
                    :items="yearsArray"
                    v-model="experience"
                    label="Select Years"
                    single-line
                    item-text="text"
                    item-value="text"
                    required
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs6>
                  <v-btn class="btnColor" dark @click="save">
                    <v-icon left>save</v-icon>Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>

    <v-flex v-if="user.experience!==''" xs12 class="pa-3">
      {{user.experience}} 
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ExpertExperienceIndex",
  components: {},
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      dialog: false,
      experience: null,
      yearsArray: [
        { text: "1 Year" },
        { text: "2 Years" },
        { text: "3 Years" },
        { text: "4 Years" },
        { text: "5 Years" },
        { text: "Above 5 years" }
      ]
    };
  },
  methods: {
    save() {
      const data = {
        experience: this.experience
      };

      //dispatch
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.experience = null;
          self.dialog = false;
        });
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.experience {
  font-size: 18px;
}
</style>

